import { Browser } from '@capacitor/browser';

import { CORTEX_SUPPORT_URL } from 'clipsal-cortex-utils/src/constants/common-constants';

/**
 * Opens the external Cortex support page, the destination for every non-Energy-Masters
 * "Contact Support" touchpoint. Desktop opens a new tab so the app is left intact; mobile and
 * native replace the current window, where the in-app browser owns the back navigation.
 *
 * Prefer {@link useContactSupport} where the Energy Masters support modal is also required.
 */
export async function openCortexSupportPage(isDesktopViewport: boolean): Promise<void> {
  await Browser.open({ url: CORTEX_SUPPORT_URL, windowName: isDesktopViewport ? '_blank' : '_self' });
}
